import ContentRoutes from './ContentRoutes';

const Content = () => {
  return <ContentRoutes />;
};

export default Content;
